import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/removed-ebay-listings';

export default function Example() {
  return (
    <>
      <Head>
        <title>Removed Listings on eBay: Why It Happens and How to Avoid It</title>
        <meta
          name='description'
          content='Listing on eBay is fun and profitable, but sometimes, listings on this platform get removed. Find out here the reasons behind the removal and learn some tips on how you can avoid it.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/removed-ebay-listings' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/removed-ebay-listings' />
        <meta property='og:title' content='Removed Listings on eBay: Why It Happens and How to Avoid It' />
        <meta
          property='og:description'
          content='Listing on eBay is fun and profitable, but sometimes, listings on this platform get removed. Find out here the reasons behind the removal and learn some tips on how you can avoid it.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='March 29th, 2022' />
        <meta property='article:modified_time' content='March 29th, 2022' />
        <meta property='article:tag' content='eBay' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
